export default {
  meta: {
    title: '定点打靶'
  }
};
